import { format as dateFormat, isPast as dateIsPast } from "date-fns"
import { fr } from "date-fns/locale"

type Format = "date" | "time"

const FORMATS: Record<Format, string> = {
  date: "EEEE d MMMM yyyy",
  time: "HH:mm",
}

export const formatDate = (date: Date | string | number, format: Format): string => {
  if (typeof date === "string") {
    if (format === "time" && date.length === 16 && date.indexOf("T") === 10) {
      // no timezone => show timezone-less time (contentful fix):
      return date.substr(11)
    }
    date = new Date(date)
  }
  return dateFormat(date, FORMATS[format], { locale: fr })
}

export const formatInterval = (start: Date | string | number, end: Date | string | number): string => {
  return `${formatDate(start, "date")} de ${formatDate(start, "time")} à ${formatDate(end, "time")}`
}

export const isPast = (dateStr: string): boolean => dateIsPast(new Date(dateStr))
